import { CheckmarkOutline } from "@carbon/icons-react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import ProceedButton from "../../../../components/buttons/proceedButton/ProceedButton";
import useNavigateTo from "../../../../hooks/useNavigateTo";

interface SplitConfirmationProps {
  newSplitDeliveryId: string;
}
const SplitConfirmation = (props: SplitConfirmationProps) => {
  const { t } = useTranslation();
  const { id: idFromUrl } = useParams();
  const { navigateToDeliveryDetails } = useNavigateTo();
  const { newSplitDeliveryId } = props;

  return (
    <div
      className="split-container-confirmation mt-20"
      data-testid="splitOrderConfirmation"
    >
      <div className="summary-check-data mb-5 mt-18">
        <CheckmarkOutline
          className="summary-check-data-icon-success"
          data-testid="summary-check-data-icon-success"
          size={32}
        />
        <div className="summary-check-data-text">{t("orderSplitSuccess")}</div>
      </div>
      <div className="split-container-confirmation-button-container mt-10">
        <div className="page-content-button-container-button-center">
          <ProceedButton
            onProceed={() => navigateToDeliveryDetails(idFromUrl || "")}
            value={t("toOriginalDetails")}
            variant="outlined"
          />
        </div>
        <div className="page-content-button-container-button-center">
          <ProceedButton
            onProceed={() => navigateToDeliveryDetails(newSplitDeliveryId)}
            value={t("toNewSplitDetails")}
            variant="outlined"
          />
        </div>
      </div>
    </div>
  );
};
export default SplitConfirmation;
